// src/utils/UserObserver.js
class UserObserver {
    constructor() {
        this.subscribers = [];
        this.clear();
    }

    subscribe(callback) {
        if (!this.subscribers.includes(callback)) {
            this.subscribers.push(callback);
        }
        callback(this.getUserData(), this.token);
        return () => {
            this.subscribers = this.subscribers.filter(sub => sub !== callback);
        };
    }

    setData({ userName, userEmail, userType, userMLNOFlag, userAISearchEnabled }, token, expireTime, refreshToken) {
        console.log('UserObserver setData:', { userName, userEmail, userType, userMLNOFlag, userAISearchEnabled }, token, expireTime, refreshToken);
        this.userName = userName;
        this.userEmail = userEmail;
        this.userType = userType;
        this.userMLNOFlag = userMLNOFlag;
        this.userAISearchEnabled = userAISearchEnabled;
        this.token = token;
        this.refreshToken = refreshToken;
        this.expireTime = expireTime;
        this.notify();
    }

    clear() {
        this.userName = null;
        this.userEmail = null;
        this.userType = null;
        this.userMLNOFlag = null;
        this.userAISearchEnabled = null;
        this.token = null;
        this.refreshToken = null;
        this.expireTime = null;
        this.notify();
    }

    /**
     * Notifies all subscribers of the current user data and token.
     *
     * Subscribers are functions that expect two arguments: the user data and the token.
     * The user data is an object with properties: userName, userEmail, userType, userMLNOFlag.
     * The token is the current token that is used to access the backend API.
     */
    notify() {
        console.log('UserObserver notify:', this.getUserData(), this.token);
        const userData = this.getUserData();
        this.subscribers.forEach(cb => cb(userData, this.token));
    }

    getUserData() {
        return {
            userName: this.userName,
            userEmail: this.userEmail,
            userType: this.userType,
            userMLNOFlag: this.userMLNOFlag,
            userAISearchEnabled: this.userAISearchEnabled,
        };
    }

    getUserName() { return this.userName; }
    getToken() { return this.token; }
    getRefreshToken() { return this.refreshToken; }
    getUserType() { return this.userType; }
    isUserMLNO() { return this.userMLNOFlag; }
    isAISearchEnabled() { return Boolean(this.userAISearchEnabled); }
    getExpireTime() { return this.expireTime; }
    getUserEmail() { return this.userEmail; }

    setRefreshHandler(handler) {
        this._refreshHandler = handler;
    }

    async refreshToken() {
        if (this._refreshHandler) {
            return await this._refreshHandler();
        }
        console.warn('UserObserver: No refresh handler registered');
        return false;
    }
}

export const userSession = new UserObserver();
